var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"polls-list"},[(_vm.loaded)?_c('active-table',{ref:"table",attrs:{"config":_vm.config,"showTableActions":false,"scope":{status: _vm.status},"pageBaseUrl":"/polls/list/completed"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }